export default __webpack_public_path__ + "bdb38530b70b98a564716a38e8db16e6.svg";